<template>
  <div v-cloak class="specialDetail">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">专家专栏</div>
        <div class="texts">新鲜资讯、随时播报、一网打尽</div>
      </div>
    </div>

    <!-- 中间内容 -->
    <div class="Bread">
      <Bread :list="breadList" />
    </div>

    <div id="w-1200px" class="r-container">
      <div class="con-left">
        <div class="fon-20 height500 pa-r-20">
          {{ detail.Name }}
        </div>
        <div class="c-8a fon-14 flex f-center ma-t-15 b-b-1-e3 pa-b-10 p-r">
          <img :src="detail.ExpertsImage" class="ma-r-10 athor b-r-50" />
          <span class="c-000 c-p" @click="toExpertDetail(detail.ExpertsId)">{{
            detail.ExpertsName
          }}</span>
          <img src="../img/icontime.png" class="ma-l-40 ma-r-10 img_12" />
          {{ detail.ReleaseTime }}
          <img src="../img/iconeye.png" class="ma-l-40 ma-r-10 img_14" />
          {{ detail.ViewCount }}人浏览
          <i
            class="iconfont icon-fenxiang11 ma-l-20 share-btn"
            @mouseenter="shareMouseenter()"
            @mouseleave="shareMouseleave()"
          ></i>
          <!-- 分享框 -->
          <div
            class="box-share"
            id="box-share"
            @mouseenter="shareMouseenter()"
            @mouseleave="shareMouseleave()"
          >
            <div class="flex f-center">
              <div class="t-center">
                <img
                  v-if="qrUrl"
                  :src="qrUrl"
                  alt=""
                  srcset=""
                  width="120"
                  class="img-qrCode"
                />
                <div class="t-center">微信扫码分享</div>
              </div>
              <div class="p-r">
                <img
                  src="../img/weibo.png"
                  alt=""
                  srcset=""
                  width="60"
                  class="c-p ma-l-10"
                  title="点击分享"
                  @click="weibo(item)"
                />
              </div>
              <div class="p-r ma-l-20">
                <img
                  src="../img/qzone.png"
                  alt=""
                  srcset=""
                  width="60"
                  class="c-p"
                  title="点击分享"
                  @click="QQShare(item)"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="flex c-8a pa-tb-20" v-if="detail.Keywords">
            <div>标签:</div>
            <div class="c-234775">{{ detail.Keywords }}</div>
          </div>
        </div>
        <div class="ma-t-20 lh-html" v-html="detail.Content"></div>
      </div>
      <div class="con-right-wrap">
        <div class="con-right">
          <div class="special-right">
            <div class="flex">
              <img src="../img/qrcode.png" alt="" class="width50 b-e3" />
              <div class="flex flex-direction f-jcenter pa-l-10">
                <div>了解更多信息请关注官方微信</div>
                <div class="bold c-234775 t-center ma-t-20">【数智方舟】</div>
              </div>
            </div>
            <!-- 热门标签 -->
            <!-- <div class="pa-t-20">
              <div class="bold b-b-1-e3 pa-b-10">热门标签</div>
              <div class="flex f-between f-wrap ma-t-10">
                <div class=" fon-16 tips2 flex f-center f-jcenter" v-for="(items, indx) in 8" :key="indx">
                  大数据
                </div>
              </div>
            </div> -->
            <!-- 推荐文章 -->
            <div class="pa-t-20">
              <div class="bold b-b-1-e3 pa-b-10">推荐文章</div>
              <div class="ma-t-20">
                <div
                  class="right_box c-p"
                  v-for="(item, index) in detail.SimilarList"
                  :key="index"
                  @click.stop="toDetail(item.Id)"
                >
                  <img :src="item.Image" v-if="item.Image" />
                  <div class="ma-t-10 fon-18 font-bold t-omit-1">
                    {{ item.Name }}
                  </div>
                  <div class="c-8a fon-14 flex f-center ma-t-10">
                    <img src="../img/icontime.png" class="ma-r-10 img_12" />
                    {{ item.ReleaseTime }}
                    <img
                      src="../img/iconeye.png"
                      class="ma-l-40 ma-r-10 img_14"
                    />
                    {{ item.ViewCount }}人浏览
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.share-btn{
  position: absolute;
  right: 0;
}
.athor {
  width: 30px;
  height: 30px;
}

.img-qrcode {
  .frame-img {
    margin: 20px auto;
    border: 2px solid #e4e7ed;
    height: 200px;
    width: 200px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 99%;
    }
  }
}

.con-right-wrap {
  width: 30%;

  .tips2 {
    background: #bfbfbf;
    height: 30px;
    border-radius: 10px;
    margin-bottom: 10px;
    min-width: 26%;
  }

  .right_box:not(:last-child) {
    border-bottom: 1px #eee solid !important;
  }

  .right_box {
    width: 100%;
    max-height: 287px;
    margin: 0 auto;
    margin-top: 20px;
    padding-bottom: 10px;

    & img {
      width: 100%;
      height: 199px;
      object-fit: cover;
    }

    .img_12 {
      height: 12px;
      width: 12px;
    }

    .img_14 {
      height: 14px;
      width: 14px;
    }
  }
}

.con-right {
  width: 100%;
  background: #fff;
  padding: 20px;
  height: auto;
}

.con-left {
  width: 65%;
  background: #fff;
  padding: 20px;
}

.t-justify {
  text-align: justify;
}

.p-r {
  position: relative;
}

.specialDetail {
  .el-tabs__nav-wrap {
    width: 100%;
  }

  .box-share {
    position: absolute;
    width: 290px;
    right: 0;
    top: 0;
    // border: 1px solid red;
    background: #fff;
    padding: 10px;
    box-shadow: 0 1px 4px 0 #bdbdbd;
    border-radius: 2px;
    display: none;
  }

  .h-auto {
    height: auto;
  }

  .chunk {
    display: inline-block;
    width: 5px;
    height: 23px;
    background: #234775;
    border-radius: 3px;
  }

  .li-news {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 20px;

    .chunk-top {
      width: 20px;
      height: 20px;
      border-radius: 3px;
      display: inline-block;
      text-align: center;
      color: #fff;
      line-height: 19px;
      margin-right: 6px;
    }

    .chunk-top1 {
      background: #ff0000;
    }

    .chunk-top2 {
      background: #ff2b2b;
    }

    .chunk-top3 {
      background: #ff5e5e;
    }

    .chunk-top-other {
      background: #7d7d7d;
    }
  }
}

.el-tabs--top {
  width: 100%;
}

.c-8a {
  color: #8a8a8a;
}

.c-009294 {
  color: #009294;
}

.img_22 {
  width: 15px;
  height: 15px;
}

.ma-lr-15 {
  margin: 0 18px;
}

.c-41 {
  color: #414141;
}

.rz {
  width: 50%;
  margin: 15px auto;
  border-radius: 3px;
  text-align: center;
  padding: 10px 10px;
  background-color: #e6e6e6;
  color: #000;
  font-weight: 500;
}

.containerss {
  width: 1200px;

  margin: 0 auto;
  background: #ffffff;
  padding: 0px 14px 25px 14px;
  box-sizing: border-box;

  .fy {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product-main {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .product-list {
      width: 370px;
      height: 121px;
      margin-right: 20px;
      margin-bottom: 38px;
      display: flex;
      justify-content: flex-start;

      .p-image {
        width: 35%;
        height: 121px;
        margin-right: 9px;

        .p-imgs {
          width: 121px;
          height: 121px;
          border-radius: 10px;
        }
      }

      .p-title {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 8px;
      }

      .p-detail {
        // width:100%;
        font-size: 14px;
        height: 38px;
        line-height: 19px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .p-right {
        width: 65%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .download {
        width: 90px;
        height: 30px;
        background: rgba(15, 117, 189, 1);
        border-radius: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}

.specialDetail {
  min-width: 1200px;
  background: rgba(245, 247, 250, 1);
}

.specialDetail .swiper {
  width: 100%;
  height: 314px;
  background-image: url(../img/ExpertColumn.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

  .toptexts {
    width: 736px;
    position: absolute;
    top: 28%;
    margin: 0 auto;
    left: 50%;
    margin-left: -368px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

    color: #fff;
    opacity: 0.75;
    text-align: center;

    .texts {
      line-height: 30px;
      letter-spacing: 3px;
      font-size: 16px;
    }

    .imgtitle {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}

.fy {
  margin-top: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.specialDetail .r-container {
  width: 1200px;
  // height: 600px;
  // min-height: 500px;
  box-sizing: border-box;
  // padding: 30px 40px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  min-height: 1150px;

  display: flex;
  justify-content: space-between;
}

.specialDetail .r-container {
  margin-bottom: 30px;

  .el-tabs__header {
    display: flex;
    justify-content: left;
    margin-top: 15px;
  }

  .el-tabs__content {
    // min-width: 1080px;
    margin: 0 auto;
  }

  .el-tabs__item {
    padding: 0 60px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }

  .el-tabs__active-bar {
    height: 4px;
    font-weight: bold;
    background: #234775;
  }

  .is-active {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #234775;
  }

  .el-tabs__content {
    // margin-top: 45px;
  }
}

.specialDetail .student {
  width: 1100px;
  height: 106px;
  margin-bottom: 32px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  .img-left {
    width: 20%;
    height: 106px;

    .img-lefts {
      width: 187px;
      height: 106px;
    }
  }

  .text-right {
    width: 80%;

    .title {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #333333;
      margin-top: 3px;
      margin-bottom: 5px;
    }

    .text-detail {
      padding-right: 100px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 18px;
      font-family: MicrosoftYaHei;
      color: rgba(102, 102, 102, 1);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    .icons {
      // width: 100%;
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .deletes {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          i {
            font-size: 18px;
          }
        }
      }

      .icons-left {
        width: 100%;
        padding-right: 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .icons-left-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }

      .delete-right {
        width: 40%;

        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
    }
  }
}

.three_box {
  width: 100%;
  height: auto;
  margin-top: 12px;

  .boxs-r {
    background: #ffffff;

    // box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    // border-radius: 10px;
    .img_263 {
      width: 230px;
      height: 149px;
      object-fit: cover;
    }

    .img_30 {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: 205px;
      left: 10px;
    }
  }
}

.ma-t-60 {
  margin-top: 60px !important;
}

.ma-t-10 {
  margin-top: 10px !important;
}

.ma-t-12 {
  margin-top: 12px !important;
}

.height40 {
  height: 36px;
}

.c-234775 {
  color: #234775;
}

.search-box {
  position: relative;

  .search {
    position: absolute;
    background: #eeeeee;
    border-radius: 33px;
    width: 280px;

    .el-input {
      border-radius: 33px;

      .el-input__inner {
        border-radius: 33px;
        background: #eeeeee;
        border: none !important;
      }
    }

    .search-btn {
      background: #00479d;
      border-radius: 0px 33px 33px 0px;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      width: 100px;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
<script>
import { newsDetail } from "../api.js";
import Bread from "../components/Bread.vue";

//二维码生成
import QRCode from "qrcode";
// studycollect
export default {
  name: "specialDetail",
  components: {
    Bread,
  },
  data() {
    return {
      activeName: "",
      pageIndex: 1,
      pageSize: 16,
      name: "",
      totals: 0, //一个分类下的总条数
      dataList: [],
      kinds: [],
      breadList: [
        { name: "专家专栏", path: "Expert" },
        { name: "专栏详情", path: "/specialDetail" },
      ],
      sortType: 0,
      hotNewsList: [],
      qrUrl: "",
      detail: {},
    };
  },

  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    next();
  },
  watch: {
    $route() {
      window.scroll(0, 0);
    },
  },

  // 其他页面进来时更新初始数据
  activated() {},

  methods: {
    //跳转专家详情
    toExpertDetail(id) {
      this.$router.push({
        path: "/expertDetail",
        query: { id: id },
      });
    },
    //获取专栏详情
    getDetail() {
      let data = {
        id: this.id,
      };
      newsDetail(data).then((res) => {
        if (res.data.Code == 0) {
          this.detail = res.data.Data;

          //绘制二维码
          this.loadDataQrUrl();
        }
      });
    },
    //微博分享
    weibo() {
      var query = {
        title: this.detail.Name,
        url: "http://www.fz-ai.net/specialDetail?id=" + this.detail.Id,
      };
      if (this.detail.Image) {
        query.pic = this.detail.Image;
      }
      let url =
        "http://service.weibo.com/share/share.php?" + this.buildUrlQuery(query);
      window.open(url);
    },
    //QQ空间分享
    QQShare() {
      var query = {
        title: this.detail.Name,
        summary: this.detail.summary,
        url: "http://www.fz-ai.net/specialDetail?id=" + this.detail.Id,
      };
      if (this.detail.Image) {
        query.pics = this.detail.Image;
      }
      let url =
        "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?" +
        this.buildUrlQuery(query);
      window.open(url);
    },
    //拼接url
    buildUrlQuery(query) {
      var queryItems = [];
      for (var k in query) {
        queryItems.push(k + "=" + encodeURIComponent(query[k] || ""));
      }
      return queryItems.join("&");
    },
    //获取二维码图片url
    loadDataQrUrl() {
      var _this = this;
      QRCode.toDataURL(
        "http://www.fz-ai.net/specialDetail?id=" + this.detail.Id,
        {},
        function (err, url) {
          if (err) throw err;
          _this.qrUrl = url;
        }
      );
    },
    //鼠标悬浮分享按钮
    shareMouseenter() {
      let dom = document.getElementById("box-share");
      dom.style.display = "block";
    },
    //鼠标移开分享按钮
    shareMouseleave() {
      let dom = document.getElementById("box-share");
      dom.style.display = "none";
    },
    login() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$confirm("您还未登录请先登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/Login");
          })
          .catch(() => {
            return false;
          });
      } else {
        return true;
      }
    },

    toDetail(id = 1) {
      this.$router.push({
        path: "/specialDetail",
        query: { id: id },
      });
    },

    upload(e) {
      window.open(e, "_blank");
    },

    // 设置保存页码
    save() {
      let kinds = this.kinds;
      this.saves = kinds.map((item) => {
        return { id: item.Id, page: 1 };
      });
    },

    // 详情
    collect(id) {
      this.$router.push({
        path: "/Study-detail",
        query: { paths: "/Resource", name: "学习资源", id: id },
      });
    },
  },
};
</script>
